import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControlLabel, Radio } from '@mui/material';
import axios from 'axios';
import moment from 'moment/moment';
import { CreateChancel, ErrMessage } from 'components';
import { FindErrorItem, FindLoad, FindSuccessItem, token, useModal } from 'utils';
import { claimActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, systemActions } from 'store';
import { Skeleton } from '@mui/material';

const typeEnums = {
    OFFICE_ALLY: 'OFFICE_ALLY',
    AVAILITY: 'AVAILITY',
    TL_CLEARINGHOUSE: 'TL_CLEARINGHOUSE',

    // AUTOMATIC: 'AUTOMATIC',
    MANUAL: 'MANUAL',
    ASPDF: 'ASPDF',
    ASTAB: 'ASTAB',
    ASEDI: 'ASEDI',
    NONE: 'NONE',
};

const ACTION_TYPE = 'SUBMIT_CLAIM';
const INTEGRATION_ACTION_TYPE = 'CAN_USE_INTEGRATION';

export const SelectSubmissionMethod = ({ selectedList, afterSuccess }) => {
    const { close } = useModal();
    const canUseIntegrations = useSelector((state) => state.system.canUseIntegrations);
    const success = FindSuccessItem(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const dispatch = useDispatch();
    const [error, setError] = useState(false);
    const loader = FindLoad(ACTION_TYPE);
    const loadIntegrations = FindLoad(INTEGRATION_ACTION_TYPE);
    const [inputs, setInputs] = useState({
        downloadType: typeEnums.NONE,
    });
    const [loadDownload, setLoadDownload] = useState(false);

    useEffect(() => {
        dispatch(systemActions.canUseIntegration());
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }, [dispatch]);

    const handleDownload = () => {
        setLoadDownload(true);

        const enumType = inputs?.downloadType === typeEnums.ASPDF ? 'PDF' : inputs?.downloadType === typeEnums.ASEDI ? 'EDI' : 'TAB';

        axios({
            url: `/claim/1500Forms/${enumType}`,
            method: 'POST',
            responseType: inputs?.downloadType === typeEnums.ASPDF ? 'blob' : 'text',
            headers: { 'access-token': `${token()}` },
            data: {
                claimIds: selectedList,
            },
        })
            .then((response) => {
                const blob = new Blob([response?.data], { type: 'text/tab-separated-values' });
                const url =
                    inputs?.downloadType === typeEnums.ASPDF
                        ? window.URL.createObjectURL(new Blob([response?.data]))
                        : window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                const fileType =
                    inputs?.downloadType === typeEnums.ASPDF ? 'pdf' : inputs?.downloadType === typeEnums.ASEDI ? 'edi' : 'tab';

                // const fileType = inputs?.downloadType === typeEnums.ASPDF ? 'pdf' : 'tab';
                // link.setAttribute('download', `${item?.displayId ? `${item?.displayId},` : ''}${moment().format('MM/DD/YYYY')}-1500Form.${fileType}`);
                link.setAttribute('download', `${moment().format('MM/DD/YYYY')}-1500Form.${fileType}`);
                document.body.appendChild(link);
                link.click();
                close();
            })
            .catch((error) => {
                close();
            })
            .finally(() => {
                setLoadDownload(false);
            });
    };

    useEffect(() => {
        if (success) {
            if (inputs?.type === typeEnums.MANUAL && inputs?.downloadType !== typeEnums.NONE) {
                handleDownload('');
            }
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            afterSuccess();

            // if (inputs?.type === typeEnums.AUTOMATIC) {
            if (
                inputs?.type === typeEnums.OFFICE_ALLY ||
                inputs?.type === typeEnums.AVAILITY ||
                inputs?.type === typeEnums.TL_CLEARINGHOUSE ||
                inputs?.downloadType === typeEnums.NONE
            ) {
                close();
            }
        }
    }, [success]);

    const handleExport = () => {
        if (inputs?.type) {
            if (
                inputs?.type === typeEnums.OFFICE_ALLY ||
                inputs?.type === typeEnums.AVAILITY ||
                inputs?.type === typeEnums.TL_CLEARINGHOUSE
            ) {
                dispatch(claimActions.submitClaim(selectedList, '', inputs?.type));
            } else {
                dispatch(claimActions.submitClaim(selectedList, ''));
            }
            // const submitType = inputs?.type === typeEnums.AUTOMATIC ? 'officeAlly' : 'manual';
            // dispatch(claimActions.submitClaim(selectedList, '', submitType));
        } else {
            setError(true);
        }
    };

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        setError(false);
    };

    const integrationsList = [
        {
            type: typeEnums.OFFICE_ALLY,
            label: 'Submit via Office Ally (Automatic)',
            canUse: !canUseIntegrations?.activeOfficeAllySFTP,
            name: 'Office Ally',
        },
        {
            type: typeEnums.AVAILITY,
            label: 'Submit via Availity (Automatic)',
            canUse: !canUseIntegrations?.activeAvaility,
            name: 'Availity',
        },
        {
            type: typeEnums.TL_CLEARINGHOUSE,
            label: 'Submit via TherapyLake (Automatic)',
            canUse: !canUseIntegrations?.activeTlClearinghouse,
            name: 'TherapyLake',
        },
    ];

    return (
        <div style={{ width: 400 }}>
            <p className="download-modal-title">Select Submission Method</p>
            <p className="download-modal-desc">Please choose how you would like to submit the selected claims</p>
            <div className="download-1500form-modal-body">
                {loadIntegrations?.length ? (
                    <div>
                        <div className="form-type-box-passive" style={{ padding: 0, marginBottom: '12px' }}>
                            <Skeleton variant="rounded" width={'100%'} height={96} />
                        </div>
                        <div className="form-type-box-passive" style={{ padding: 0, marginBottom: '12px' }}>
                            <Skeleton variant="rounded" width={'100%'} height={96} />
                        </div>
                        <div className="form-type-box-passive" style={{ padding: 0, marginBottom: '12px' }}>
                            <Skeleton variant="rounded" width={'100%'} height={96} />
                        </div>
                    </div>
                ) : (
                    <div>
                        {integrationsList?.map((i, j) => (
                            <div
                                key={j}
                                className={inputs?.type === i?.type ? 'form-type-box-active' : 'form-type-box-passive'}
                                style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}
                            >
                                <FormControlLabel
                                    style={{ opacity: i?.canUse ? 0.5 : 1 }}
                                    disabled={i?.canUse}
                                    onChange={handleChange}
                                    name={'type'}
                                    value={i?.type}
                                    label={i?.label}
                                    control={
                                        <Radio
                                            style={{ color: inputs?.type === i?.type ? '#347AF0' : '#D0D5DD' }}
                                            checked={inputs?.type === i?.type}
                                        />
                                    }
                                />
                                {i?.canUse && (
                                    <p className="office-ally-warning-text">
                                        {`Please enable ${i?.name} integration in`}
                                        <a
                                            style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }}
                                            href={'/system'}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                        >
                                            {' '}
                                            settings{' '}
                                        </a>
                                        to submit claims.
                                    </p>
                                )}
                            </div>
                        ))}

                        {/*<div*/}
                        {/*    className={inputs?.type === typeEnums.AUTOMATIC ? 'form-type-box-active' : 'form-type-box-passive'}*/}
                        {/*    style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}*/}
                        {/*>*/}
                        {/*    <FormControlLabel*/}
                        {/*        style={{ opacity: !canUseIntegrations?.activeSFTP ? 0.5 : 1 }}*/}
                        {/*        disabled={!canUseIntegrations?.activeSFTP}*/}
                        {/*        onChange={handleChange}*/}
                        {/*        name={'type'}*/}
                        {/*        value={typeEnums.AUTOMATIC}*/}
                        {/*        label="Submit via Office Ally (Automatic)"*/}
                        {/*        control={<Radio*/}
                        {/*            style={{ color: inputs?.type === typeEnums.AUTOMATIC ? '#347AF0' : '#D0D5DD' }}*/}
                        {/*            checked={inputs?.type === typeEnums.AUTOMATIC}*/}
                        {/*        />}*/}
                        {/*    />*/}
                        {/*    {!canUseIntegrations?.activeSFTP &&*/}
                        {/*        <p className="office-ally-warning-text">*/}
                        {/*            Please enable Office Ally integration in*/}
                        {/*            <a style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }} href={'/system'}*/}
                        {/*               target={'_blank'}> settings </a>*/}
                        {/*            to submit claims.*/}
                        {/*        </p>*/}
                        {/*    }*/}
                        {/*</div>*/}

                        {/*<div*/}
                        {/*    className={inputs?.type === typeEnums.AUTOMATIC ? 'form-type-box-active' : 'form-type-box-passive'}*/}
                        {/*    style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}*/}
                        {/*>*/}
                        {/*    <FormControlLabel*/}
                        {/*        style={{ opacity: !canUseIntegrations?.availity ? 0.5 : 1 }}*/}
                        {/*        disabled={!canUseIntegrations?.availity}*/}
                        {/*        onChange={handleChange}*/}
                        {/*        name={'type'}*/}
                        {/*        value={typeEnums.AUTOMATIC}*/}
                        {/*        label="Submit via Availity (Automatic)"*/}
                        {/*        control={<Radio*/}
                        {/*            style={{ color: inputs?.type === typeEnums.AUTOMATIC ? '#347AF0' : '#D0D5DD' }}*/}
                        {/*            checked={inputs?.type === typeEnums.AUTOMATIC}*/}
                        {/*        />}*/}
                        {/*    />*/}
                        {/*    {!canUseIntegrations?.availity &&*/}
                        {/*        <p className="office-ally-warning-text">*/}
                        {/*            Enable Availity integration in*/}
                        {/*            <a style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }} href={'/system'}*/}
                        {/*               target={'_blank'}>*/}
                        {/*                settings </a> to submit claims.*/}
                        {/*        </p>*/}
                        {/*    }*/}
                        {/*</div>*/}
                    </div>
                )}

                <div
                    className={inputs?.type === typeEnums.MANUAL ? 'form-type-box-active' : 'form-type-box-passive'}
                    style={{ borderColor: error ? '#F07379' : '' }}
                >
                    <FormControlLabel
                        onChange={handleChange}
                        name={'type'}
                        value={typeEnums.MANUAL}
                        label="Manual Submission"
                        control={
                            <Radio
                                style={{ color: inputs?.type === typeEnums.MANUAL ? '#347AF0' : '#D0D5DD' }}
                                checked={inputs?.type === typeEnums.MANUAL}
                            />
                        }
                    />
                    {inputs?.type === typeEnums.MANUAL && (
                        <div className="download-manual-types-body">
                            {[
                                { value: typeEnums.NONE, label: 'None (Skip)' },
                                { value: typeEnums.ASPDF, label: 'Download as PDF' },
                                { value: typeEnums.ASTAB, label: 'Tab-delimited (.tab)' },
                                { value: typeEnums.ASEDI, label: 'ASC X12 (.edi)' },
                            ].map(({ value, label }) => (
                                <FormControlLabel
                                    key={value}
                                    style={{ color: '#172B4D', width: 160 }}
                                    onChange={handleChange}
                                    name="downloadType"
                                    value={value}
                                    label={label}
                                    control={
                                        <Radio
                                            style={{
                                                color: inputs?.downloadType === value ? '#347AF0' : '#D0D5DD',
                                                fontSize: 12,
                                            }}
                                            checked={inputs?.downloadType === value}
                                        />
                                    }
                                />
                            ))}
                        </div>
                    )}
                </div>
                <ErrMessage
                    style={{ marginBottom: '12px' }}
                    text={error ? 'Please select method' : backError?.error ? backError?.error : ''}
                />
            </div>

            <div>
                <CreateChancel
                    loader={loadDownload || loader?.length}
                    disabled={loadIntegrations?.length}
                    create={'Submit'}
                    chancel={'Cancel'}
                    onCreate={handleExport}
                    onClose={close}
                    buttonWidth="300px"
                />
            </div>
        </div>
    );
};
